import React from "react";
 
import { Helmet } from "react-helmet";
function Disclaimer(){
return(
<div >


<Helmet>
 
<title>Codeexampler Disclaimer</title>
<meta name="description" content="Codeexampler Disclaimer.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners and  questions of all technology like java tutorial, python tutorial,c# tutorial for beginners in deeply knowledge " />
<link rel="canonical" href="https://www.codeexampler.com/disclaimer" />
</Helmet>



<div className="m-5">
<h1>Disclaimer for codeexampler</h1>


<p className="m-4">The information contained in <a href="https://www.codeexampler.com/">codeexampler</a> is for general information purposes only. The information is provided by <a href="https://www.codeexampler.com/">codeexampler</a> and while we endeavour to keep the information up to date and correct, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability or availability with respect to the website or the information, products, services, or related graphics contained on the website for any purpose. Any reliance you place on such information is therefore strictly at your own risk.<br/><br/><br/>

In no event will we be liable for any loss or damage including without limitation, indirect or consequential loss or damage, or any loss or damage whatsoever arising from loss of data or profits arising out of, or in connection with, the use of this website.<br/><br/><br/>

Through this website you are able to link to other websites which are not under the control of <a href="https://www.codeexampler.com/">codeexampler</a>. We have no control over the nature, content and availability of those sites. The inclusion of any links does not necessarily imply a recommendation or endorse the views expressed within them.<br/><br/><br/>

Every effort is made to keep the website up and running smoothly. However, <a href="https://www.codeexampler.com/">www.codeexampler.com</a> takes no responsibility for, and will not be liable for, the website being temporarily unavailable due to technical issues beyond our control.<br/><br/>
</p>

</div>
   

 
    </div>


)

}
export default Disclaimer;